export default __webpack_public_path__ + "static/media/house-green.0b69a28c.svg";